import {
    emptyDatiqInput,
    emptyDatiqInputErrorMessages,
    emptyDatiqOption,
    DatiqChecklistErrorTypes,
    DatiqChecklistTypes,
    IDatiqChecklist,
    IDatiqChecklistErrorMessages,
    IDatiqChecklistItem
} from '@dat/datiq-components-pkg/utils';
import {
    DATIQ_DEFAULT_ARRAY,
    DATIQ_DEFAULT_BOOLEAN,
} from '@dat/datiq-core/models';

export const DATIQ_DEFAULT_CHECKLIST_ERROR_MESSAGE_MAX_CHECK_ITEMS = `You can only check {{${DatiqChecklistErrorTypes.MaxCheckedItems}.maxLength}} items.`;
export const DATIQ_DEFAULT_CHECKLIST_ERROR_MESSAGE_MIN_CHECK_ITEMS = `You must select {{${DatiqChecklistErrorTypes.MinCheckedItems}.minLength}} items.`;
export const emptyDatiqChecklistErrorMessages: IDatiqChecklistErrorMessages = {
    ...emptyDatiqInputErrorMessages,
    [DatiqChecklistErrorTypes?.MaxCheckedItems]:
        DATIQ_DEFAULT_CHECKLIST_ERROR_MESSAGE_MAX_CHECK_ITEMS,
    [DatiqChecklistErrorTypes?.MinCheckedItems]:
        DATIQ_DEFAULT_CHECKLIST_ERROR_MESSAGE_MIN_CHECK_ITEMS,
};

export const emptyDatiqChecklistItem: IDatiqChecklistItem = {
    ...emptyDatiqOption,
};

export const emptyDatiqChecklist: IDatiqChecklist = {
    ...emptyDatiqInput,
    items: DATIQ_DEFAULT_ARRAY as IDatiqChecklistItem[],
    checklistType: DatiqChecklistTypes.Check,
    multiple: DATIQ_DEFAULT_BOOLEAN,
    errorMessages: {
        ...emptyDatiqChecklistErrorMessages,
    },
};
